module.exports = __webpack_public_path__ + "img/remove_red_eye-24px-1.bf6fc9de.svg";